/**
 * Mirrors PortalApi LoginStatusRules for Access Management Salesforce approval UI.
 */
export const EMPLOYEE_EMAIL_DOMAIN = '@metabolon.com';
export const TESTER_EMAIL_SUBSTRING = 'sqa+';
export const LEGACY_CUTOFF_UTC = new Date('2026-04-10T00:00:00.000Z');

export const SALESFORCE_APPROVAL_MANAGED_AUTOMATICALLY_MESSAGE =
	'Approval is managed automatically for this user.';

/** Matches PortalApi LoginStatusRules.IsLoginAllowedStatus. */
export const LOGIN_ALLOWED_STATUSES = new Set([
	'Employee',
	'Legacy',
	'Contact',
	'Approved Lead',
]);

export const isLoginAllowedStatus = (status) => LOGIN_ALLOWED_STATUSES.has(status);

/** Matches PortalApi LoginStatusRules (Employee/Legacy skip manual approval UI). */
export const showSalesforceApprovalControl = (status) =>
	!!status && status !== 'Employee' && status !== 'Legacy';

export const isSalesforceApprovedFromStatus = (status) => isLoginAllowedStatus(status);

export const isEmployeeEmail = (email) => {
	const normalized = (email || '').trim().toLowerCase();
	return normalized.endsWith(EMPLOYEE_EMAIL_DOMAIN)
		&& !normalized.includes(TESTER_EMAIL_SUBSTRING);
};

export const isLegacyUser = (userCreatedAtUtc) => {
	if (!userCreatedAtUtc) return false;
	const createdAt = userCreatedAtUtc instanceof Date
		? userCreatedAtUtc
		: new Date(userCreatedAtUtc);
	if (Number.isNaN(createdAt.getTime())) return false;
	return createdAt.getTime() < LEGACY_CUTOFF_UTC.getTime();
};

/** True when admin manual Salesforce approval toggle should not be shown. */
export const isSalesforceApprovalManagedAutomatically = (
	email,
	userCreatedAtUtc = null,
	status = null,
) => {
	if (status === 'Employee' || status === 'Legacy') return true;
	return isEmployeeEmail(email) || isLegacyUser(userCreatedAtUtc);
};
